export default __webpack_public_path__ + "static/user3-8c1075b71decd16f21caf37bd6db2065.webp";